import React from 'react';
import { Settings, Zap } from 'lucide-react';
import clsx from 'clsx';
import { ConfigurationPanelProps } from '../types/analysis';
import { SALES_STAGES } from '../constants';

export const ConfigurationPanel: React.FC<ConfigurationPanelProps> = ({
  salesStage,
  onSalesStageChange,
  onAnalyze,
  disabled,
  meetingTypes = [],
}) => {
  return (
    <div className="glass-card rounded-3xl p-8 backdrop-blur-xl animate-slide-up">
      <div className="mb-6">
        <div className="flex items-center space-x-3 mb-2">
          <Settings className="w-6 h-6 text-primary-600 dark:text-primary-400" />
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">
            Konfiguracja analizy
          </h2>
        </div>
        <p className="text-gray-600 dark:text-gray-300">
          Wybierz etap sprzedaży, aby otrzymać dostosowane wglądy dla swojej rozmowy
        </p>
      </div>

      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
            Etap sprzedaży
          </label>
          <div className="relative">
            <select
              value={salesStage}
              onChange={(e) => {
                console.log('🔍 DEBUG: Select onChange:', e.target.value, 'Previous:', salesStage);
                onSalesStageChange(e.target.value);
              }}
              className="w-full bg-white/70 dark:bg-gray-800/70 border border-gray-200 dark:border-gray-700 
                         rounded-2xl px-4 py-4 pr-12 text-gray-800 dark:text-gray-200 
                         focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent
                         transition-all duration-200 backdrop-blur-sm"
              style={{ appearance: 'none', WebkitAppearance: 'none', MozAppearance: 'none' }}
            >
              {Array.isArray(meetingTypes) && meetingTypes.length > 0
                ? meetingTypes.map((meetingType) => (
                    <option key={meetingType.id} value={meetingType.name}>
                      {meetingType.name}
                      {meetingType.description && ` - ${meetingType.description}`}
                    </option>
                  ))
                : SALES_STAGES.map((stage) => (
                    <option key={stage} value={stage}>
                      {stage}
                    </option>
                  ))
              }
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <div className="pt-4 border-t border-gray-200/50 dark:border-gray-700/50">
          <button
            onClick={onAnalyze}
            disabled={disabled}
            className={clsx(
              'w-full flex items-center justify-center space-x-3 py-4 px-8 rounded-2xl font-semibold text-lg',
              'transition-all duration-300 transform',
              disabled
                ? 'bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed'
                : 'btn-primary hover:scale-105 active:scale-95 group'
            )}
          >
            <Zap className={clsx(
              'w-6 h-6',
              disabled ? 'text-gray-500' : 'text-white group-hover:rotate-12 transition-transform duration-200'
            )} />
            <span>
              {disabled ? 'Wprowadź transkrypt' : 'Analizuj transkrypt'}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};